var map = {
	"./1.jpg": 6662,
	"./2.jpg": 4417,
	"./3.jpg": 84,
	"./4.jpg": 7871,
	"./5.jpg": 6162,
	"./6.jpg": 2093,
	"./7.jpg": 3520,
	"./8.jpg": 5131
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7107;